type OptionsFilter = Record<string, unknown>

/**
 * Параметр `filters` для запиту опцій з `inputProps.filter`-подібного об'єкта: скаляр → `=`,
 * `{ op, field?, value? }` → як задано, null/undefined пропускаються — як у Core SelectInput.
 * Відмінність: масив → `in` (Core ставить на кожен елемент окреме `=` через and, і такий
 * фільтр нічого не знаходить).
 */
export const buildOptionsFilters = (filter: OptionsFilter | null | undefined): string | null => {
    if (!filter || typeof filter !== 'object') return null
    const and: Array<{ field: string; op: string; value: unknown }> = []
    Object.entries(filter).forEach(([key, value]) => {
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
            if (value.length > 0) and.push({ field: key, op: 'in', value })
            return
        }
        if (typeof value === 'object' && typeof (value as Record<string, unknown>)['op'] === 'string') {
            const condition = value as Record<string, any>
            and.push({ field: condition['field'] ?? key, op: condition['op'], value: condition['value'] ?? null })
            return
        }
        and.push({ field: key, op: '=', value })
    })
    return and.length > 0 ? JSON.stringify({ and }) : null
}
